export default __webpack_public_path__ + "static/media/hover2.7f74722f.png";